
(function() {
  var result = { translations: { "fr-ca": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} jours", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h{{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, poste {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fr-ca": "static-7.1206"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1206",
    "ar-eg": "static-7.1206",
    "bg": "static-7.1206",
    "bn": "static-7.1206",
    "ca-es": "static-7.1206",
    "cs": "static-7.1206",
    "da": "static-7.1206",
    "de": "static-7.1206",
    "el": "static-7.1206",
    "en-gb": "static-7.1206",
    "en": "static-7.1206",
    "es-mx": "static-7.1206",
    "es": "static-7.1206",
    "et": "static-7.1206",
    "fi": "static-7.1206",
    "fr-ca": "static-7.1206",
    "fr": "static-7.1206",
    "he-il": "static-7.1206",
    "hi": "static-7.1206",
    "hr": "static-7.1206",
    "hu": "static-7.1206",
    "id": "static-7.1206",
    "it": "static-7.1206",
    "ja": "static-7.1206",
    "ko": "static-7.1206",
    "lt": "static-7.1206",
    "ms": "static-7.1206",
    "nl": "static-7.1206",
    "no": "static-7.1206",
    "pl": "static-7.1206",
    "pt-br": "static-7.1206",
    "pt-pt": "static-7.1206",
    "ro": "static-7.1206",
    "ru": "static-7.1206",
    "sk": "static-7.1206",
    "sl": "static-7.1206",
    "sv": "static-7.1206",
    "th": "static-7.1206",
    "tl": "static-7.1206",
    "tr": "static-7.1206",
    "uk": "static-7.1206",
    "vi": "static-7.1206",
    "x-pseudo": "static-7.1206",
    "zh-cn": "static-7.1206",
    "zh-hk": "static-7.1206",
    "zh-tw": "static-7.1206"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fr-ca', {version: 'static-7.1206'}); }
})();


